import Swiper, {Navigation, Pagination} from 'swiper';
// import Swiper and modules styles


// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

export function init_sliders() {
  new Swiper(".frontpage-gallery", {
    preloadImages: true,
    navigation: {
      nextEl: '.swiper-button-next'
    },
    autoplayDisableOnInteraction: false,
    slidesPerView: 1,
    loop: true,
    observer: true,
    observeParents: true,
    parallax: true,
    breakpoints: {
      // when window width is >= 768px
      1200: {
        slidesPerView: 2,
        spaceBetween: 20
      },
    }
  });

  let slider_rooms = new Swiper(".room-gallery", {
    preloadImages: true,
    pagination: {
      el: '.swiper-pagination',
    },
    autoplayDisableOnInteraction: false,
    slidesPerView: 1,
    loop: true,
    observer: true,
    observeParents: true,
    parallax: true,
  });

  $(".swiper-pagination-bullet").click(function (e) {
    e.preventDefault();
    slider_rooms.slideNext();
  });
}


